import { isError } from "lodash";
import { isAxiosError, isErrorCode, isErrorResponse } from "./typeguard";
import { ErrorObject } from "./errorObject";

export const createErrorObject = (error: unknown): ErrorObject => {
  if (isError(error)) {
    if (isAxiosError(error)) {
      if (error.response) {
        const { data } = error.response;
        if (isErrorResponse(data) && data) {
          const { code, message } = data;
          if (isErrorCode(code)) {
            return {
              errorCode: code,
              message,
              statusCode: error.response.status,
            };
          }
        }
      }
      // 最低限、AxiosErrorである場合
      return {
        errorCode: "E009999",
        message: error.message,
        statusCode: error.response?.status,
      };
    }
    // 最低限、Errorである場合
    return {
      errorCode: "E009999",
      message: error.message,
      stack: error.stack,
    };
  }
  // 何か不正なthrowが行われた場合
  return { errorCode: "E009999" };
};
